import React, { useCallback, useEffect } from 'react';
import { useSelector, RootStateOrAny, useDispatch } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import jsCookie from 'js-cookie';

import { AuthActions, AuthState } from 'store/ducks/auth';
import { usePermissions } from 'hooks';
import { apiGeneral, notify } from 'services';

import { NewPassword } from 'pages/NewPassword';
interface Props {
  [propName: string]: any;
}

export const PrivateRoute: React.FC<Props> = ({
  component: Component,
  hasPermission,
  ...rest
}) => {
  const { checkUserPermission } = usePermissions();

  const auth = useSelector<RootStateOrAny>((state) => state.auth) as AuthState;

  const dispatch = useDispatch();

  const canAccess = useCallback(() => {
    if (!auth.loggedIn) return false;

    if (hasPermission) {
      const approvedAccess = checkUserPermission(hasPermission);
      if (!approvedAccess) {
        notify('error', 'Acesso negado');
      }
      return approvedAccess;
    }

    return true;
  }, [auth, checkUserPermission, hasPermission]);

  const renderComponent = useCallback(
    (props) => {
      if (canAccess() && auth.data) {
        const { days_left_password } = auth.data;
        const isPasswordExpired =
          days_left_password !== null && days_left_password <= 0;

        if (auth.data.new_password || isPasswordExpired) {
          return <NewPassword {...props} />;
        }
        if (!auth.data.new_password) {
          return <Component {...props} />;
        }
      }

      return (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      );
    },
    [Component, auth, canAccess]
  );

  async function getData(accessToken: Record<string, string>) {
    try {
      apiGeneral.defaults.headers.Authorization = `Bearer ${accessToken.webcolToken}`;

      const { data } = await apiGeneral.post('get-user-data');
      dispatch(
        AuthActions.loginSuccess({
          ...data,
          accessToken: accessToken.webcolToken,
        })
      );
    } catch (error) {
      console.log(error);
      jsCookie.remove('_iconic');
      dispatch(AuthActions.logoutRequest());
    }
  }

  const accessToken = jsCookie.get('_iconic');
  useEffect(() => {
    (() => {
      if (auth.loggedIn && !accessToken) {
        dispatch(AuthActions.logoutRequest());
      }
    })();
  }, [accessToken]);

  return <Route {...rest} render={(props) => renderComponent(props)} />;
};
